// Map card renderer color names to CSS custom properties from _tokens.sass.
// By using CSS variables instead of hardcoded hex values, the card renderer
// output automatically adapts when the theme changes without re-rendering.
const COLOR_ALIASES = {
  // Semantic aliases
  text: 'var(--color-text-color)',
  subtleText: 'var(--color-metadata-text-color)',
  background: 'var(--color-white)',
  border: 'var(--color-default-border-color)',
  borderDark: 'var(--color-gray500)',
  borderLight: 'var(--color-gray200)',
  primary: 'var(--color-brand-secondary)',
  info: 'var(--color-purple400)',
  warning: 'var(--color-yellow400)',
  error: 'var(--color-brand-danger)',

  // Base colors
  white: 'var(--color-white)',
  black: 'var(--color-black)',

  // Shorthand color names
  green: 'var(--color-green400)',
  grey: 'var(--color-gray500)',
  purple: 'var(--color-purple400)',
  red: 'var(--color-red400)',
  yellow: 'var(--color-yellow400)',

  // Grey scale
  grey100: 'var(--color-gray100)',
  grey200: 'var(--color-gray200)',
  grey300: 'var(--color-gray300)',
  grey400: 'var(--color-gray400)',
  grey500: 'var(--color-gray500)',
  grey600: 'var(--color-gray600)',
  grey700: 'var(--color-gray700)',
  grey800: 'var(--color-gray800)',
  grey900: 'var(--color-gray900)',

  // Green scale
  green100: 'var(--color-green100)',
  green400: 'var(--color-green400)',
  green700: 'var(--color-green700)',

  // Red scale
  red100: 'var(--color-red100)',
  red400: 'var(--color-red400)',
  red700: 'var(--color-red700)',

  // Purple scale
  purple100: 'var(--color-purple100)',
  purple400: 'var(--color-purple400)',
  purple700: 'var(--color-purple700)',

  // Yellow scale
  yellow100: 'var(--color-yellow100)',
  yellow400: 'var(--color-yellow400)',
  yellow700: 'var(--color-yellow700)',

  // Blue-grey scale
  blueGrey100: 'var(--color-bluegrey100)',
  blueGrey300: 'var(--color-bluegrey300)',
  blueGrey500: 'var(--color-bluegrey500)',
  blueGrey800: 'var(--color-bluegrey800)',
};

export function getCardRendererHostConfig(baseConfig = {}) {
  return {
    ...baseConfig,
    styles: {
      ...baseConfig.styles,
      colorAliases: {
        ...baseConfig.styles?.colorAliases,
        ...COLOR_ALIASES,
      },
    },
  };
}
